import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Flower2 } from "lucide-react";

const FlowerDrop = () => {
  const serviceData = {
    serviceName: "Flower Drop",
    heroImage: require("../../assets/flowerdrop_main.jpeg"),
    heroTagline: "Divine Celebrations from Above",
    heroDescription:
      "Create magical moments with our aerial flower drop services for temples, statues, and special occasions. Experience the beauty of petals showering from the sky.",
    overviewTitle: "Aerial Flower Drop Services",
    overviewText: `HighKraft Aviation offers spectacular aerial flower drop services that add a divine and memorable touch to religious ceremonies, statue inaugurations, and special occasions. Watch as thousands of flower petals gracefully descend from the heavens, creating an unforgettable visual spectacle.

Flower drops from helicopters have become an integral part of temple festivals, deity processions, and major religious celebrations across India. Whether it's the inauguration of a grand statue, a temple anniversary celebration, or a special puja ceremony, our flower drop service transforms ordinary events into extraordinary experiences.

Our experienced team handles every aspect of the flower drop operation – from sourcing fresh flowers to coordinating the perfect timing and coverage area. We work closely with event organizers and religious authorities to ensure the flower drop aligns perfectly with the ceremony's most auspicious moments.`,
    useCases: [
      {
        title: "Temple Festivals",
        description:
          "Showering flowers during major temple festivals and deity processions.",
      },
      {
        title: "Statue Inaugurations",
        description:
          "Grand flower drops for the unveiling of religious statues and monuments.",
      },
      {
        title: "Religious Processions",
        description:
          "Accompanying rath yatras and religious processions with aerial flower showers.",
      },
      {
        title: "Wedding Ceremonies",
        description:
          "Creating magical moments during outdoor wedding ceremonies.",
      },
      {
        title: "Anniversary Celebrations",
        description:
          "Marking special anniversaries of temples, institutions, or organizations.",
      },
      {
        title: "National Events",
        description:
          "Flower drops for national celebrations, memorials, and civic occasions.",
      },
    ],
    safetyFeatures: [
      {
        title: "Crowd Safety Protocols",
        description:
          "Strict adherence to altitude and distance guidelines when flying over gatherings.",
      },
      {
        title: "Pre-Event Survey",
        description:
          "Thorough assessment of the venue and surrounding airspace before the event.",
      },
      {
        title: "Coordination with Authorities",
        description:
          "All necessary permissions and coordination with local authorities.",
      },
      {
        title: "Experienced Pilots",
        description:
          "Pilots trained in low-altitude operations and precision flying.",
      },
      {
        title: "Weather Monitoring",
        description: "Continuous weather assessment to ensure safe operations.",
      },
      {
        title: "Backup Plans",
        description:
          "Alternative arrangements in case of unfavorable conditions.",
      },
    ],
    galleryImages: [
      require("../../assets/flowerdrop_main1.jpeg"),
      require("../../assets/flowerdrop_main.jpeg"),
      "https://images.pexels.com/photos/931018/pexels-photo-931018.jpeg",
    ],
    faqs: [
      {
        question: "What types of flowers are used for flower drops?",
        answer:
          "We typically use rose petals, marigold flowers, and other locally sourced fresh flowers. The flower selection can be customized based on the occasion and client preferences.",
      },
      {
        question: "How much area can a single flower drop cover?",
        answer:
          "A single pass can cover an area of approximately 100-200 meters. Multiple passes can be arranged to cover larger areas or extend the duration of the flower shower.",
      },
      {
        question: "How far in advance should we book?",
        answer:
          "We recommend booking at least 2-3 weeks in advance for flower drop services to ensure proper planning, flower procurement, and all necessary permissions.",
      },
      {
        question:
          "Can you match the flower drop timing with a specific moment?",
        answer:
          "Yes, we coordinate closely with event organizers to time the flower drop precisely with important moments like muhurat, unveiling, or aarti timings.",
      },
      {
        question: "What permissions are required?",
        answer:
          "We handle all aviation permissions, ATC coordination, and local authority clearances. Clients may need to coordinate venue permissions with local administration.",
      },
    ],
    icon: Flower2,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default FlowerDrop;
